import { Typography } from '@mui/material';

const Footer = () => {
  /**
   * Propósito: Pie de la landing con tokens de tema (no navy/blanco fijos).
   */
  /**
   * Output:
   * @returns JSX — Enlaces y datos de contacto sobre `background`/`foreground`
   */
  return (
    <div className='bg-background text-foreground py-10 max-w-7xl mx-auto'>
      <div className='max-w-7xl mx-auto px-6 grid grid-cols-4 md:grid-cols-2 lg:grid-cols-4 gap-8'>
        {/* Logo and Description */}
        <div className='space-y-4'>
          <img
            src='https://landing-pago-abogado-prod.s3.us-east-2.amazonaws.com/pay-my-lawer-logo.png'
            alt='Pay My Lawyer Logo'
            className='w-28'
          />
          <Typography variant='body2' className='text-sm leading-relaxed'>
            Pay My Lawyer offers user-friendly, streamlined, secure payment processing tailored for
            law firms. Manage your client inventory, calendar, payment history, and referrals with
            ease. Designed by legal professionals for legal professionals. No subscription fees,
            just simple, transparent transaction pricing.
          </Typography>
          <button className='bg-primary-strong text-primary-foreground px-4 py-2 rounded hover:bg-primary-hover'>
            Facebook
          </button>
        </div>

        {/* Links */}
        <div style={{ alignItems: 'center', marginTop: '130px' }}>
          <Typography className='text-foreground text-lg font-semibold mb-4'>Link</Typography>
          <ul className='space-y-2 text-sm text-foreground-muted'>
            <li className='hover:text-foreground cursor-pointer'>Home</li>
            <li className='hover:text-foreground cursor-pointer'>Features</li>
            <li className='hover:text-foreground cursor-pointer'>Pricing</li>
            <li className='hover:text-foreground cursor-pointer'>About Us</li>
            <li className='hover:text-foreground cursor-pointer'>Privacy Policy</li>
          </ul>
        </div>

        {/* Help & Support */}
        <div style={{ alignItems: 'center', marginTop: '130px' }}>
          <Typography className='text-foreground text-lg font-semibold mb-4'>Help & Support</Typography>
          <ul className='space-y-2 text-sm text-foreground-muted'>
            <li className='hover:text-foreground cursor-pointer'>FAQ</li>
            <li className='hover:text-foreground cursor-pointer'>Contact Us</li>
            <li className='hover:text-foreground cursor-pointer'>Support</li>
          </ul>
        </div>

        {/* Address */}
        <div style={{ alignItems: 'center', marginTop: '130px' }}>
          <Typography className='text-foreground text-lg font-semibold mb-4'>Our Address</Typography>
          <ul className='space-y-2 text-sm text-foreground-muted'>
            <li>
              <span className='font-bold'>Email: </span>ceo@paymylawyer.cc
            </li>
            <li>
              <span className='font-bold'>Phone: </span>956-466-6918
            </li>
            <li>
              <span className='font-bold'>Address: </span>1304 E Adams St. Brownsville, Tx. 78520
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className='mt-8 text-center text-sm text-foreground-muted'>
        © {new Date().getFullYear()} Pay My Lawyer. All rights reserved.
      </div>
    </div>
  );
};

export default Footer;
